import { api, unwrap } from '@/data/api/client';
import { config } from '@/config';
import type { AuthInfo, AuthResponse } from '@/domain/types';

export const authRepo = {
  info: () => unwrap<AuthInfo>(api.GET('/auth', {})),

  loginEmail: (email: string, password: string) =>
    unwrap<AuthResponse>(api.POST('/auth/email/login', { body: { email, password } })),

  registerEmail: (email: string, password: string, displayName?: string, refCode?: number) =>
    unwrap<AuthResponse>(api.POST('/auth/email/register', {
      body: { email, password, displayName: displayName ?? null, refCode: refCode ?? null },
    })),

  forgetPass: (email: string) =>
    unwrap(api.POST('/auth/email/forgetpass', { body: { email } })),

  resetPass: (token: string, newPassword: string) =>
    unwrap(api.POST('/auth/email/resetpass', { body: { token, newPassword } })),

  google: (token: string, refCode?: number) =>
    unwrap<AuthResponse>(api.POST('/auth/google', { body: { token, refCode: refCode ?? null } })),

  facebook: (token: string, refCode?: number) =>
    unwrap<AuthResponse>(api.POST('/auth/facebook', { body: { token, refCode: refCode ?? null } })),

  x: (token: string, refCode?: number) =>
    unwrap<AuthResponse>(api.POST('/auth/x', { body: { token, refCode: refCode ?? null } })),

  telegram: (initData: string, refCode?: number) =>
    unwrap<AuthResponse>(api.POST('/auth/telegram', { body: { initData, refCode: refCode ?? null } })),

  verifyEmail: async (token: string): Promise<{ message: string }> => {
    const res = await fetch(`${config.apiBaseUrl}/auth/email/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    });
    const body = await res.json();
    if (!res.ok) throw new Error(body?.error ?? `Verification failed (${res.status})`);
    return body;
  },

  logout: () => unwrap(api.POST('/auth/logout', {})),

  deleteAccount: () => unwrap(api.DELETE('/auth/account', {})),
};
